import angular from 'angular'
import $ from 'jquery'
import { Permissions } from '@/client_auth/permissions'

export default angular.module('adminPanel.auth', []).factory('auth', [
  '$http',
  '$q',
  'configuration',
  function($http, $q, config) {
    const endPoint = `${config.root}auth`;
    let userPromise;

    const service = {
      getCurrentUser: function() {
        if (!userPromise) {
          userPromise = $http.get(endPoint + '/current_user').then(function(response) {
            service.currentUser = response.data.user;
            const permissions = response.data.permissions;
            service.currentUser.permissions = permissions;
            return service.currentUser;
          }).catch(function(error) {
            console.error('Error getting current user:', error);
            service.currentUser = null;
            userPromise = undefined;
            return $q.reject(error);
          });
        }
        return userPromise;
      },
      getCsrfToken() {
        const value = `; ${document.cookie}`
        const parts = value.split(`; gblcs=`)
        if (parts.length === 2) {
          return decodeURIComponent(
            parts
              .pop()
              .split(';')
              .shift()
          )
        }
      },
      doesUserHavePermission(requiredPerms) {
        return this.getCurrentUser().then(user => {
          let userPerms = (user && user.permissions) || [];
          if (!requiredPerms || !Array.isArray(requiredPerms) || !requiredPerms.length) {
            return true;
          }
          if (userPerms.includes(Permissions.Anything)) {
            return true;
          }
          return userPerms.some(userPerm => requiredPerms.indexOf(userPerm) > -1);
        }).catch(error => {
          console.error('Permission check failed:', error);
          return false;
        });
      },
      hasUserOpsPermission() {
        return this.doesUserHavePermission([Permissions.UserOps]);
      },
      signIn: function(email, password, csrfToken) {
        var deferred = $q.defer()
        $http
          .post(
            endPoint + '/sign_in',
            $.param({ email: email, password: password, authenticity_token: csrfToken }),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          )
          .then(
            function(response) {
              deferred.resolve(response.data.user_uuid)
            },
            function(response) {
              if (response.status === 401) {
                console.log(response.data)
                deferred.reject(response.data)
              }
            }
          )
        return deferred.promise
      },
      signOut: function() {
        var deferred = $q.defer()
        $http.get(endPoint + '/sign_out').then(
          function(response) {
            deferred.resolve(response.data.status)
          },
          function(response) {
            deferred.reject(response.data)
          }
        )
        return deferred.promise
      },

      signInRack: function(uuid) {
        var deferred = $q.defer()
        $http
          .post(endPoint + '/rack/sign_in', 'uuid=' + encodeURIComponent(uuid), {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          })
          .then(
            function(response) {
              deferred.resolve(response.data.user_uuid)
            },
            function(response) {
              deferred.reject(response.data)
            }
          )
        return deferred.promise
      },

      async clearUserSessions(uuid, sessionID) {
        let body = ''
        if (sessionID) {
          body = 'session_id=' + encodeURIComponent(sessionID)
        }
        try {
          const resp = await $http.post(`${config.apiEndPoint}/sign_out/user/${uuid}`, body, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          })
          return resp.data
        } catch (err) {
          return err
        }
      }
    }

    return service
  }
])
